import { Link } from 'react-router-dom'
import { FiChevronRight as FiBreadcrumb } from 'react-icons/fi'
import Layout from '../components/Layout/Layout'

const Terms = () => {
  const termsData = [
    {
      id: 1,
      text: 'Para poder enviar el producto se necesita confirmar el pago en su totalidad.'
    },
    {
      id: 2,
      text: 'El producto se entrega tal y como se ve en la imagen.'
    },
    {
      id: 3,
      text: 'En productos personalizados es necesario tener un acercamiento con nosotros para hacer el trabajo lo más parecido a lo que se quiere.'
    },
    {
      id: 4,
      text: 'El precio total incluye impuestos.'
    },
    {
      id: 5,
      text: 'Para poder realizar la compra de alguno de nuestros artículos es necesario descargar nuestra App, realizar su registro, seleccionar el artículo de su interés y posteriormente realizar el pago correspondiente.'
    },
    {
      id: 6,
      text: 'Sobre la política de envíos. Si el producto ofrece envío gratis sólo es exclusivo en México, de otra manera cotizar envío.'
    },
    {
      id: 7,
      text: 'Al llegar el producto tiene que revisarlo y si tiene algún defecto de fabricación o no es el que eligió, mandar evidencia para hacer válida la devolución.'
    },
    {
      id: 8,
      text: 'Si el producto es dañado por mal uso o mal manejo no hay devolución.'
    },
    {
      id: 9,
      text: 'Los pagos serán procesados mediante la pasarela de Openpay.'
    }
  ]

  return (
    <Layout>
      <div className="py-8 sm:py-12">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Breadcrumb */}
          <nav className="flex items-center text-sm sm:text-base text-primary-gray mb-4 sm:mb-6 font-body font-extralight flex-wrap" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-primary-dark hover:font-normal transition-colors">
              Inicio
            </Link>
            <FiBreadcrumb className="mx-1 sm:mx-2 flex-shrink-0" />
            <span className="font-normal">
              Términos y Condiciones
            </span>
          </nav>

          {/* Page Header */}
          <div className="mb-8">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-title font-semibold text-primary-text mb-4">
              Términos y condiciones
            </h1>
          </div>
                    
          {/* Terms List - Static Display */}
          <div className="space-y-6">
            {termsData.map((item) => (
              <div key={item.id}>
                <p className="font-body font-light text-primary-text text-lg leading-relaxed">
                  {item.id}. {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Terms